var render = function render(){var _vm=this,_c=_vm._self._c;return (Number(_vm.params.curso_id))?_c('v-container',{attrs:{"fluid":""}},[_c('Formulario',{attrs:{"getParams":this.params}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }